import React from "react";

function AdminQuotes() {
  return <div>Admin Quotes Page</div>;
}

export default AdminQuotes;
